import React from 'react';
import { FaqList } from '@components/FaqList';
import { ColoredBlockSection } from '@sections/shared/ColoredBlockSection';
import { Layout, Seo } from '@layout';
import {
  RegistryHeroSection,
  RegistryCashFreeGiftingSection,
  RegistryPublicCatalogSection,
  RegistryCross,
  UniversalRegistry,
  ChooseExperiencesSection,
} from '@sections/cash-fund-registry';

import { registryPageData } from '@data-ts/pages/cash-fund-registry';
import { faqQuestionsData } from '@data-ts/components/FaqQuestions';

const PAGE: MarcomPageName = 'cash-fund-registry';

const CashRegistry = () => {
  const moreTimeTogetherSectionId = 'Bucket_Listing';
  return (
    <Layout
      transparentJoyLogoColor="neutra6"
      transparentHeaderButtonVariant="primary"
      transparentHeaderLinkVariant="navLink"
      isTransparentHeader={true}
      headerScrollThresholdVh={35}
      page={PAGE}
    >
      <Seo
        title={registryPageData.seo.title}
        canonicalURL={'https://withjoy.com/cash-fund-registry/'}
        description={registryPageData.seo.content}
        ogImage={'common/meta_share/registry.jpg'}
      />
      <RegistryHeroSection />
      <RegistryCashFreeGiftingSection />
      <ChooseExperiencesSection />
      <div id={moreTimeTogetherSectionId}>
        <UniversalRegistry />
      </div>
      <RegistryPublicCatalogSection />
      <RegistryCross />
      <ColoredBlockSection
        isLeftAligned
        backgroundColor="white"
        sideHeaderText={'Frequently <br/> Asked <br/> Questions'}
        sectionId="Cash_Registry_Design_FAQ"
        isToggleNeeded={true}
      >
        <FaqList accordion={true} questionNodes={[...faqQuestionsData.cashFundRegistry, ...faqQuestionsData.general]} color="neutra6" />
      </ColoredBlockSection>
    </Layout>
  );
};

export default CashRegistry;
